import { useState } from "react";
import { toast } from "sonner";
import { EvidenceBase as EvidenceBaseGrid } from "@lumanity/ui/evidence";
import * as DocumentToolbar from "@/components/DocumentToolbar";
import PageLayout from "@/components/PageLayout";
import PageHeader from "@/components/PageHeader";
import UploadDocument from "@/components/UploadDocument";
import { useOpenEvidenceDocument, useRefreshDocuments } from "@/lib/evidence";

const EvidenceBase = () => {
  const [uploadOpen, setUploadOpen] = useState(false);
  const openDocument = useOpenEvidenceDocument();
  const refreshDocuments = useRefreshDocuments();

  return (
    <PageLayout fullHeight>
      <PageHeader title="Evidence Base" subtitle="Browse, search, and manage all documents across projects" />
      <EvidenceBaseGrid
        fillHeight
        filter={(doc) => doc.ownership.toLowerCase() === "public"}
        onOpenDocument={openDocument}
        onSaved={() => refreshDocuments()}
        onDeleted={() => refreshDocuments()}
        onError={(e) => toast.error(e.message)}
        toolbarActions={<DocumentToolbar.UploadButton onClick={() => setUploadOpen(true)} />}
      />
      <UploadDocument open={uploadOpen} onOpenChange={setUploadOpen} lockedOwnership="Public" />
    </PageLayout>
  );
};

export default EvidenceBase;
